import React from 'react';
import { Modal } from "antd";
import errorImage from "../../assets/img/error-image.svg";

const ErrorModal = ({ visible, onClose, errorMessage }) => {
    return (
      <Modal
        visible={visible}
        onCancel={onClose}
        onOk={onClose}
        footer={null}
        centered
        className="exception-modal"
      >
        <div className="modal-content">
          <img className="error-img" src={errorImage} alt="Error" />
          <span className="exception-modal-text">
            {errorMessage || "Something went wrong. Please try again later."}
          </span>
        </div>
      </Modal>
    );
  };

export default ErrorModal;
